/*
 * What an escalation row in a work order's history moved (AB#1624).
 *
 * Pure, in the shape of workOrderSearch.js, so the rule can be tested without rendering the list.
 *
 * Escalation leaves the order in Open like any other reopening, so the status pair alone cannot
 * say what happened. A row is a hand-over when it names departments or trades — the server writes
 * both pairs on every escalation, the departments even when only the trade moved. Rows written
 * before trades were logged name departments only.
 */
const sameId = (a, b) => (a ?? null) === (b ?? null);

export const isHandover = (entry) =>
  entry?.fromDepartmentId != null ||
  entry?.toDepartmentId != null ||
  entry?.fromTradeId != null ||
  entry?.toTradeId != null;

/*
 * Which pair leads the row, and whether the trade gets a line of its own under it.
 *
 * The department leads when it moved, as it always did before trades. The trade leads when it
 * moved alone: that is a crew change inside one department, and led by the departments it would
 * read "Escalated: Mekanik → Mekanik". When both moved, the department leads and the trade follows
 * on the line below, since the department's trade is the one most readers will expect.
 *
 * Null for an ordinary status change.
 */
export function getHandoverShape(entry) {
  if (!isHandover(entry)) return null;

  const departmentMoved = !sameId(entry.fromDepartmentId, entry.toDepartmentId);
  const tradeMoved = !sameId(entry.fromTradeId, entry.toTradeId);

  return {
    leadsWith: tradeMoved && !departmentMoved ? "trade" : "department",
    showTradeLine: departmentMoved && tradeMoved,
  };
}
